import { Dashboard } from '../types/Dashboard';

export const dashboard: Dashboard = {
  actions: {
    fetching: true,
    items: []
  },
  mapData: {
    fetching: true,
    failed: false,
    markers: []
  }
};
